export const regex = (() => {
    'use strict'

    const RULES = {
        phone: {
            regex: /^\+?[0-9\s\-().]{7,25}$/,
            block: /^(?:\+?0+|\+?1{7,}|\+?2{7,}|\+?3{7,}|\+?4{7,}|\+?5{7,}|\+?6{7,}|\+?7{7,}|\+?8{7,}|\+?9{7,})$/
        },
        zip: {
            regex: /^(?=.*\d)[A-Za-z0-9]{3,8}$/,
            block: /^(00000|12345|99999)$/
        },
        name: {
            regex: /^(?:(?:von\s)?(?:Mc[A-Za-zÀ-ÿ][a-zà-ÿ]+|O'[A-Za-zÀ-ÿ][a-zà-ÿ]+|[A-Za-zÀ-ÿ][a-zà-ÿ]+))(?:[ '\-](?:Mc[A-Za-zÀ-ÿ][a-zà-ÿ]+|O'[A-Za-zÀ-ÿ][a-zà-ÿ]+|[A-Za-zÀ-ÿ][a-zà-ÿ]+))*$/u,
            block: /(asdf|qwerty|xxxx|spam|bot|fake|dummy|john\sdoe|jane\sdoe)/i
        },
        email: {
            regex: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
            block: /(spam\.com|bot\.com)/i
        },
        street: {
            regex: /^[A-Za-z0-9\s.'\-]{2,100}$/,
            block: /(asdf|qwerty|xxxx|spam|bot)/i
        }
    }

    const isHoneypot = el => el.getAttribute('tabindex') === '-1' || el.getAttribute('aria-hidden') === 'true'

    /* ---------------- VALIDATION ---------------- */

    function validate(el) {
        if (!(el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement)) return true
        if (isHoneypot(el)) return true

        const type = el.dataset.validate
        const value = el.value.trim()

        if (!type) return true
        if (!value) return true

        const rule = RULES[type]
        if (!rule) return true

        if (!rule.regex.test(value)) return false
        if (rule.block && rule.block.test(value)) return false

        if (type === 'phone') {
            const digits = value.replace(/\D/g, '')
            if (digits.length < 7 || digits.length > 15) return false
        }

        return true
    }

    /* ---------------- ERROR HANDLING ---------------- */

    function fieldWrapper(el) {
        return el.closest('.widget, .yn-form-grid-field') || el.parentNode
    }

    function clearError(el) {
        el.classList.remove('yn-error', 'yn-valid')
        const msg = fieldWrapper(el).querySelector('.yn-error-msg')
        if (msg) msg.remove()
    }

    function showError(el) {
        if (fieldWrapper(el).querySelector('.yn-error-msg')) return
        const msg = document.createElement('span')
        msg.className = 'yn-error-msg'
        msg.textContent = 'Dieses Feld ist ungültig'
        msg.style.color = 'red'
        msg.style.fontSize = '0.8em'
        fieldWrapper(el).appendChild(msg)
    }

    /* ---------------- AUTO DETECT ---------------- */

    function autoDetectFields() {
        document.querySelectorAll('[data-ynform="true"] input, [data-ynform="true"] textarea').forEach(el => {
            if (isHoneypot(el)) return // Skip honeypot fields

            const n = (el.name || '').toLowerCase()
            const t = (el.type || '').toLowerCase()

            if (t === 'email' || n.includes('email')) el.dataset.validate = 'email'
            else if (t === 'tel' || /phone|tel|telefon/.test(n)) el.dataset.validate = 'phone'
            else if (/vorname|nachname|firstname|lastname/.test(n)) el.dataset.validate = 'name'
            else if (/zip|plz|postcode/.test(n)) el.dataset.validate = 'zip'
            else if (/street|straße|strasse/.test(n)) el.dataset.validate = 'street'
        })
    }

    /* ---------------- SUBMIT BLOCK ---------------- */

    function blockInvalidSubmit() {
        document.addEventListener('submit', e => {
            const form = e.target.closest('[data-ynform="true"]')
            if (!form) return

            let firstInvalid = null

            form.querySelectorAll('input[data-validate], textarea[data-validate]').forEach(el => {
                if (isHoneypot(el)) return // Skip honeypots

                const ok = validate(el)
                clearError(el)

                if (!ok) {
                    el.classList.add('yn-error')
                    firstInvalid ??= el
                    showError(el)
                } else {
                    el.classList.add('yn-valid')
                }
            })

            if (firstInvalid) {
                e.preventDefault()
                e.stopImmediatePropagation()
                firstInvalid.focus()
            }
        }, true)
    }

    /* ---------------- LIVE CLEANUP ---------------- */

    function liveValidation() {
        document.addEventListener('input', e => {
            const el = e.target
            if (!el.matches('input[data-validate], textarea[data-validate]')) return
            if (isHoneypot(el)) return

            if (validate(el)) {
                clearError(el)
                el.classList.add('yn-valid')
            }
        })
    }

    /* ---------------- INIT ---------------- */

    function init() {
        autoDetectFields()
        blockInvalidSubmit()
        liveValidation()
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init)
    } else {
        init()
    }

    return { validate, autoDetectFields, blockInvalidSubmit }
})()
